import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Budget from "../assets/images/budget.svg";
import Goals from "../assets/images/goals.svg";
const WhyPreQualified = ({ data, loading }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL; // your image base URL

  return (
    <div className="why-pre-qualified common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>{data?.title || ""}</h2>
          <p>{data?.subtitle || ""}</p>
        </div>

        <Row className="g-4 justify-content-center">
          {(data?.cards || []).map((card, index) => (
            <Col key={index} md={6} lg={5}>
              <Card>
                <img src={`${BASE_URL}${card.icon}`} alt="" />
                <h5>{card.title}</h5>
                <p>{card.subtitle}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default WhyPreQualified;
